import { Box, Chip } from "@bca/ui-library";
import {
  DEFAULT_NUMBER_OF_DAYS_LABEL,
  DEFAULT_PURCHASES_PARAMETERS,
  DEFAULT_SORT_OPTION_LABEL,
} from "../../pages";
import { AppliedCheckboxResult } from "../Hooks/useAppliedCheckBoxes";
import { SingleSelectFacets, SingleSelectDefaultKey } from "./filtersConfig";
import prepareFiltersForApiCall from "./prepareFiltersForApiCall";

interface ActiveFiltersProps {
  selectedFilterLabel: string;
  selectedSortOptionLabel?: string;
  vrmQuery: string;
  setPurchasesUrlParams: (PurchasesUrlQueryParams) => void;
  setAdditionalFilters;
  additionalFilters;
}

const ActiveFilters: React.FunctionComponent<
  ActiveFiltersProps & AppliedCheckboxResult
> = ({
  selectedFilterLabel,
  vrmQuery,
  setPurchasesUrlParams,
  selectedSortOptionLabel = DEFAULT_SORT_OPTION_LABEL,
  appliedCheckboxes = [],
  setAppliedCheckboxes,
  setAdditionalFilters,
  additionalFilters,
  setAppliedCheckboxesSingleSelect,
}) => {
  const onClearSelectedSortOption = () => {
    setPurchasesUrlParams({
      sort: DEFAULT_PURCHASES_PARAMETERS.sort,
    });
  };
  const onClearSelectedFilter = () => {
    setPurchasesUrlParams({
      numberofDays: DEFAULT_PURCHASES_PARAMETERS.numberofDays,
    });
  };
  const onClearVrmQuery = () => {
    setPurchasesUrlParams({
      q: DEFAULT_PURCHASES_PARAMETERS.q,
    });
  };

  const removeSingleSelectCheckbox = (categoryKey) => {
    const updatedAppliedCheckboxes = setAppliedCheckboxesSingleSelect(
      "Any",
      categoryKey
    );
    const apiCallFilters = prepareFiltersForApiCall(
      "bq",
      updatedAppliedCheckboxes,
      additionalFilters
    );
    return apiCallFilters;
  };

  const removeMultipleSelectCheckbox = (
    appliedCheckboxes,
    filterKey,
    categoryKey
  ) => {
    let newState = null;

    const filterAlreadyApplied = appliedCheckboxes.find(
      (item) => item.filterKey === filterKey && item.categoryKey === categoryKey
    );
    const otherDependentFilters = appliedCheckboxes.filter(
      (item) =>
        item.parentFilterKey === categoryKey && item.groupedBy === filterKey
    );

    if (!filterAlreadyApplied && !otherDependentFilters) {
      return;
    }
    newState = [
      ...appliedCheckboxes.filter(
        (item) =>
          item !== filterAlreadyApplied &&
          !otherDependentFilters.find(
            (value) => value.filterKey === item.filterKey
          )
      ),
    ];
    setAppliedCheckboxes([...newState]);
    const newUrl = prepareFiltersForApiCall(
      "bq",
      [...newState],
      additionalFilters
    );
    return newUrl;
  };

  const onClearAppliedFilter = (appliedCheckboxes, filterKey, categoryKey) => {
    let newUrl = null;
    if (SingleSelectFacets.includes(categoryKey)) {
      newUrl = removeSingleSelectCheckbox(categoryKey);
    } else {
      newUrl = removeMultipleSelectCheckbox(
        appliedCheckboxes,
        filterKey,
        categoryKey
      );
    }
    setAdditionalFilters({
      bq: newUrl.searchParams.get("bq") || "",
    });
  };

  return (
    <Box
      paddingBottom={5}
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      css="overflow-x: auto;scrollbar-width: none;"
      marginLeft="-20px"
      marginRight="-20px"
    >
      <Box flexDirection="row" display="flex">
        <Chip
          label={`Sort: ${selectedSortOptionLabel}`}
          onRemove={onClearSelectedSortOption}
          readOnly={selectedSortOptionLabel === DEFAULT_SORT_OPTION_LABEL}
          mr={2}
          ml={5}
        />
        <Chip
          label={selectedFilterLabel}
          onRemove={onClearSelectedFilter}
          readOnly={selectedFilterLabel === DEFAULT_NUMBER_OF_DAYS_LABEL}
          mr={2}
        />
        {vrmQuery !== DEFAULT_PURCHASES_PARAMETERS.q && (
          <Chip label={vrmQuery} onRemove={onClearVrmQuery} mr={3} />
        )}
        {appliedCheckboxes.length !== 0 &&
          appliedCheckboxes.map((appliedCheckbox) => {
            const removeHandler = () =>
              onClearAppliedFilter(
                appliedCheckboxes,
                appliedCheckbox.filterKey,
                appliedCheckbox.categoryKey
              );
            return (
              <Chip
                key={appliedCheckbox.filterKey}
                label={appliedCheckbox.filterKey}
                onRemove={removeHandler}
                mr={2}
                readOnly={
                  SingleSelectFacets.includes(appliedCheckbox.categoryKey) &&
                  appliedCheckbox.filterKey === SingleSelectDefaultKey
                }
              ></Chip>
            );
          })}
      </Box>
    </Box>
  );
};

export default ActiveFilters;
